import authorization from './authorization.mock';

export const responses = [authorization];
